import { render, staticRenderFns } from "./AccessHeader.vue?vue&type=template&id=1407b274&scoped=true"
import script from "./AccessHeader.vue?vue&type=script&lang=js"
export * from "./AccessHeader.vue?vue&type=script&lang=js"
import style0 from "./AccessHeader.vue?vue&type=style&index=0&id=1407b274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407b274",
  null
  
)

export default component.exports